import Button from "@/common/button/button"
import Chevron from "@/common/icons/chevron"
import { useActiveStep } from "../store"

function SubmitStepButton({ overrideDisabled = false, loading = false }) {
  const { buttonText } = useActiveStep()
  const label = buttonText || "Nästa"

  return (
    <div className="flex ">
      <Button
        theme="lime"
        loading={loading}
        ariaLabel={label}
        className="flex-grow w-full mx-auto md:flex-grow-0 submit-step-button"
        type="submit"
        disabled={overrideDisabled}>
        <span className="relative flex items-center justify-center w-full">
          {label}
          {!loading && (
            <Chevron className="absolute right-0 w-8 h-8 fill-current shrink-0 -rotate-90" />
          )}
        </span>
      </Button>
    </div>
  )
}

export default SubmitStepButton
